import React, { memo } from 'react';
import {
  OutlinedContainer,
  StyledImage,
  TextGray,
  TextBlack,
} from '../ProductDetail.styles';
import Box from 'component/layoutComponents/Box';
import { useTheme } from 'styled-components';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Button } from '@mui/material';

const ProductCard = ({
  imgSrc,
  manufactory,
  productName,
  checked,
  onClick,
}: {
  imgSrc: string;
  manufactory: string;
  productName: string;
  checked: boolean;
  onClick: ({
    productName,
    checked,
  }: {
    productName: string;
    checked: boolean;
  }) => void;
}) => {
  const theme = useTheme() as unknown as typeof DefaultUptimeTheme;

  return (
    <OutlinedContainer padding={`${theme.uptimeSpace[0]}px`} checked={checked}>
      <Button onClick={() => onClick({ productName, checked })}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          width="180px"
          height="280px"
          padding="16px"
        >
          <Box flexBasis="5%">
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Box width="100%" height="120px">
                <StyledImage src={imgSrc} alt="image" />
              </Box>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              pt={`${theme.uptimeSpace[3]}px`}
            >
              <TextGray variant="overline" color="text.secondary">{manufactory}</TextGray>
              <TextBlack>{productName}</TextBlack>
            </Box>
          </Box>
          <Box
            width="100%"
            flexBasis="95%"
            display="flex"
            justifyContent="flex-start"
            alignItems="flex-end"
          >
            <Box display="flex" alignItems="center">
              <Box display="flex" pr={`${theme.uptimeSpace[3]}px`}>
                {checked ? (
                  <CheckIcon htmlColor={theme.uptimeColors.mainTheme.primary} />
                ) : (
                  <CheckBoxOutlineBlankIcon htmlColor={theme.uptimeColors.textColors.secondary} />
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Button>
    </OutlinedContainer>
  );
};

export default memo(ProductCard);
